import { render, staticRenderFns } from "./TextSlider.vue?vue&type=template&id=4d4b3bd3&scoped=true"
import script from "./TextSlider.vue?vue&type=script&lang=js"
export * from "./TextSlider.vue?vue&type=script&lang=js"
import style0 from "./TextSlider.vue?vue&type=style&index=0&id=4d4b3bd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b3bd3",
  null
  
)

export default component.exports